export default "__VITE_ASSET__BR10XHlV__"